import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import CourseEnrolmentEditDialog from './CourseEnrolmentEditDialog';
import DetailView from '../Common/DetailView';
import ModuleSegment from './ModuleSegment';

import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import EnrolmentIcon from 'material-ui/svg-icons/action/check-circle';

import CourseEnrolmentStore from '../../stores/CourseEnrolmentStore';
import CourseStore from '../../stores/CourseStore';
import CourseModuleStore from '../../stores/CourseModuleStore';
import CourseActions from '../../actions/CourseActionCreator';

import ROLES from '../../constants/Roles';
import { DateStyles } from '../../constants/CentricConstants';
import buildContextMenu from '../Common/BuildContextMenu';
import { formatName } from '../../utils/StringUtils';

class CourseEnrolment extends Component {

    constructor (props) {
        super(props);
        this.state = {
            open: false,
            searchText: '',
            details: {
                title: '',
                firstName: '',
                initials: '',
                lastName: '',
                method: '',
                requirement: '',
                status: '',
                progress: 0,
                score: 0,
                hash: '',
                dateStart: null,
                dateCommenced: null,
                dateCompleted: null,
                courseId: '',
                courseName: '',
                courseDescription: '',
                courseCode: '',
                courseType: '',
                courseVersion: '',
                isMandatory: null,
                isAssigned: null,
                canRetake: null
            },
            statusDialogOpen: false,
            modules: [],
            actions: [],
            menuItems: [
                {
                    link: '/dashboard/courses/enrolments',
                    icon: <EnrolmentIcon />,
                    label: 'Enrolments',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
                {
                    type:'divider'
                },
                {
                    action: () => this.setState({statusDialogOpen: true}),
                    icon: <EditIcon />,
                    label: 'Edit',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
            ],
            links: {
                back: '/dashboard/courses/enrolments',
                edit: ''
            }
        };
        this.onChange = this.onChange.bind(this);
        this.onModulesChange = this.onModulesChange.bind(this);
        this.closeStatusDialog = this.closeStatusDialog.bind(this);
        this.editEnrolment = this.editEnrolment.bind(this);
    }

    componentDidMount(){
        CourseEnrolmentStore.addChangeListener(this.onChange);
        CourseActions.getEnrolment(this.props.routeParams.id);

        this.moduleListener = CourseModuleStore.addListener(this.onModulesChange);

        this.setState({ actions: buildContextMenu(this.state.menuItems, this.context.auth) });
    }

    componentWillUnmount() {
        CourseEnrolmentStore.removeChangeListener(this.onChange);
        this.moduleListener.remove();
    }

    render(){

        const infoLink = `/dashboard/course/${this.state.details.courseId}`;
        const userLink = `/dashboard/user/${this.state.details.userId}`;

        let requirement = '';
        let enrolmentMethod = 'Booked';

        if (this.state.details.isAssigned) {
            requirement =  (!!this.state.details.isMandatory) ? 'Mandatory' : 'Optional';
            enrolmentMethod = 'Assigned';
        }

        const dateStart = (this.state.details.dateStart) ? new Date(this.state.details.dateStart).toLocaleString('en-GB', DateStyles.shortDateTime) : null;
        const dateCommenced = (this.state.details.dateCommenced) ? new Date(this.state.details.dateCommenced).toLocaleString('en-GB', DateStyles.shortDateTime) : null;
        const dateCompleted = (this.state.details.dateCompleted) ? new Date(this.state.details.dateCompleted).toLocaleString('en-GB', DateStyles.shortDateTime) : null;

        return (
            <DetailView
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className='cent-cards'>
                    <Card className="cent-card" style={{width: '100%'}}>
                        <CardHeader
                            title="Enrolment details"
                            subtitle={`No. ${this.state.details.id}`}
                        />

                        <CardText className="cent-card-text">
                            <div className='cent-flex-row'>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Name: </em>
                                            <a href={userLink}>{formatName(this.state.details)}</a>
                                        </li>
                                        <li><em>Course: </em>
                                            <a href={infoLink}>{this.state.details.courseName}</a>
                                            </li>
                                        <li><em>Code: </em>{this.state.details.courseCode}</li>
                                        <li><em>Method: </em>{enrolmentMethod}</li>
                                        <li><em>Requirement: </em>{requirement}</li>
                                        <li><em>Status: </em>{this.state.details.status}</li>
                                    </ul>
                                </div>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Enrolled: </em>{dateStart}</li>
                                        <li><em>Commenced: </em>{dateCommenced}</li>
                                        <li><em>Completed: </em>{dateCompleted}</li>
                                        <li><em>Score: </em>{this.state.details.score}</li>
                                        <li><em>Can retake:</em>{this.state.details.canRetake ? 'Yes' : 'No'}</li>
                                    </ul>
                                </div>
                            </div>
                        </CardText>
                    </Card>
                    { !!this.state.modules.length && (
                        <ModuleSegment
                            courseId={this.state.details.courseId}
                            userId={this.state.details.userId}
                            modules={this.state.modules}
                            link={'/dashboard/module/{moduleId}'}
                        />
                    )}
                </div>
                <CourseEnrolmentEditDialog
                    open={this.state.statusDialogOpen}
                    statusList={CourseStore.getStatuses()}
                    onCancel={this.closeStatusDialog}
                    onClose={this.closeStatusDialog}
                    onSave={this.editEnrolment}
                    data={{
                        status: this.state.details.status,
                        score: this.state.details.score,
                        isMandatory: this.state.details.isMandatory,
                        canRetake: this.state.details.canRetake,
                        dateStart,
                        dateCompleted
                    }}
                    closeOnSave
                />
            </DetailView>
        );
    }

    onChange(){
        const enrolment = CourseEnrolmentStore.getById(this.props.routeParams.id);

        if (enrolment) {
            ['dateStart', 'dateCommenced', 'dateCompleted'].forEach(field => {
                if (enrolment[field]) {
                    enrolment[field] = new Date(enrolment[field]);
                }
            });
            this.setState({details: enrolment});
            CourseActions.getModules(enrolment.courseId);
        }
    }

    closeStatusDialog() {
        this.setState({statusDialogOpen: false})
    }

    editEnrolment(changes) {
        CourseActions.updateEnrolment(this.state.details.courseId, this.state.details.id, changes);
    }

    onModulesChange() {
        const modules = CourseModuleStore.getModules(Number(this.state.details.courseId));
        if (modules) {
            this.setState({modules});
        }
    }

}

CourseEnrolment.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CourseEnrolment;
